module.exports = __webpack_public_path__ + "img/dropped-image-4.517510fb.png";